import { render, staticRenderFns } from "./EditIconButton.vue?vue&type=template&id=19b89714&scoped=true&"
import script from "./EditIconButton.vue?vue&type=script&lang=js&"
export * from "./EditIconButton.vue?vue&type=script&lang=js&"
import style0 from "./EditIconButton.vue?vue&type=style&index=0&id=19b89714&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b89714",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/django/wordbox-test.astroshock.ru/application/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('19b89714', component.options)
    } else {
      api.reload('19b89714', component.options)
    }
    module.hot.accept("./EditIconButton.vue?vue&type=template&id=19b89714&scoped=true&", function () {
      api.rerender('19b89714', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/app/common/utils/components/Buttons/EditIconButton.vue"
export default component.exports